import { render, staticRenderFns } from "./Estilo.vue?vue&type=template&id=86ce961a&scoped=true&"
import script from "./Estilo.vue?vue&type=script&lang=js&"
export * from "./Estilo.vue?vue&type=script&lang=js&"
import style0 from "./Estilo.vue?vue&type=style&index=0&id=86ce961a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86ce961a",
  null
  
)

export default component.exports